var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_1110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9145 15.1435L18.82 14.8586C18.596 14.1928 17.8618 13.4985 17.1874 13.3156L14.6912 12.6337C14.0142 12.4495 13.0486 12.6971 12.5534 13.1924L11.6499 14.0958C8.36672 13.2086 5.79216 10.634 4.90619 7.35139L5.80964 6.44793C6.30492 5.95266 6.55251 4.98832 6.36835 4.31139L5.68768 1.81397C5.50351 1.13827 4.80791 0.404127 4.14345 0.182613L3.8585 0.0868075C3.19276 -0.134707 2.24331 0.0893161 1.74808 0.584548L0.396693 1.93717C0.155269 2.17732 0.000969679 2.8642 0.000969679 2.86671C-0.0462958 7.15724 1.63607 11.291 4.67101 14.3259C7.69851 17.3534 11.8167 19.0333 16.0948 18.9973C16.1172 18.9973 16.824 18.8454 17.0654 18.6052L18.4168 17.2538C18.912 16.7587 19.136 15.8092 18.9145 15.1435Z",
    fill: "#1D8880"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_1110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.cdd1ab6c16e5c9589b20a0a13678e9d5.svg";
export { ForwardRef as ReactComponent };